import { useShallow } from "zustand/react/shallow";
import { useAuthStore } from "../stores/authStore";

export function useAuth() {
  return useAuthStore(
    useShallow((s) => ({
      authenticated: s.authenticated,
      setupComplete: s.setupComplete,
      loading: s.loading,
      logout: s.logout,
    })),
  );
}
